import { useEffect, useState } from "react";
import axios from '../api/axiosInstance';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";


function AdminBloodSugarHistory({ open, user, onClose, onUpdated }) {
  const [records, setRecords] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const token = localStorage.getItem("token");
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().split("T")[0];
  });
  const [endDate, setEndDate] = useState(() =>
    new Date().toISOString().split("T")[0]
  );
  const [type, setType] = useState("");

  const fetchRecords = async () => {
    if (!user) return;
    try {
      const res = await axios.get(`/api/BloodSugar?userid=${user.userId}&startDate=${startDate}&endDate=${endDate}&type=${type}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRecords(res.data);
    } catch {
      alert("查詢失敗");
    }
  };

  const handleEdit = (r) => {
    setEditingId(r.id);
    setEditData({
      recordedAt: r.recordedAt?.slice(0, 16) || "",
      glucose: r.glucose,
      notes: r.notes || "",
      isAbnormal: r.isAbnormal ?? false,
      type: r.type,
    });
  };

  const handleSave = async (id) => {
    try {
      await axios.put(
        `/api/Admin/blood-sugar/${id}`,
        { ...editData },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditingId(null);
      fetchRecords();
      if (onUpdated) onUpdated();
    } catch {
      alert("更新失敗");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("確定要刪除？")) return;
    try {
      await axios.delete(`/api/Admin/blood-sugar/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchRecords();
      if (onUpdated) onUpdated();
    } catch {
      alert("刪除失敗");
    }
  };

  useEffect(() => {
    if (open && user?.userId) fetchRecords();
  }, [open, user?.userId]);

  if (!open || !user) return null;

  return (
    <>
      <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1055 }}>
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{user.name} - 血糖紀錄</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="row g-2 align-items-end mb-3">
                <div className="col-auto">
                  <label className="form-label">起始日期</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="col-auto">
                  <label className="form-label">結束日期</label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="col-auto">
                  <label className="form-label">類別</label>
                  <select
                    className="form-control"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <option value="">全部</option>
                    <option value={0}>空腹</option>
                    <option value={1}>飯後</option>
                  </select>
                </div>
                <div className="col-auto">
                  <button className="btn btn-primary" onClick={fetchRecords}>
                    查詢
                  </button>
                </div>
              </div>
              {records.length > 0 && (
                <div style={{ width: "100%", height: 300 }}>
                  <ResponsiveContainer>
                    <LineChart data={[...records].reverse()}>
                      <XAxis dataKey="recordedAt" />
                      <YAxis domain={["auto", "auto"]} />
                      <Tooltip />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="glucose"
                        stroke="#2ecc71"
                        name="血糖"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              )}
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>最後編輯</th>
                      <th>時間</th>
                      <th>血糖</th>
                      <th>類別</th>
                      <th>備註</th>
                      <th>異常</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">尚無資料</td>
                      </tr>
                    ) : (
                      records.map((r) => (
                        editingId === r.id ? (
                          <tr key={r.id}>
                            <td>{r.sourceName}</td>
                            <td><input className="form-control" type="datetime-local" value={editData.recordedAt} onChange={(e) => setEditData({ ...editData, recordedAt: e.target.value })} /></td>
                            <td><input className="form-control" value={editData.glucose} onChange={(e) => setEditData({ ...editData, glucose: e.target.value })} /></td>
                            <td>
                              <select className="form-select" value={editData.type} onChange={(e) => setEditData({ ...editData, type: parseInt(e.target.value) })}>
                                <option value={0}>空腹</option>
                                <option value={1}>飯後</option>
                              </select>
                            </td>
                            <td><input className="form-control" value={editData.notes} onChange={(e) => setEditData({ ...editData, notes: e.target.value })} /></td>
                            <td><input type="checkbox" className="form-check-input" checked={editData.isAbnormal} onChange={(e) => setEditData({ ...editData, isAbnormal: e.target.checked })} /></td>
                            <td>
                              <button className="btn btn-success btn-sm me-1" onClick={() => handleSave(r.id)}>儲存</button>
                              <button className="btn btn-secondary btn-sm" onClick={() => setEditingId(null)}>取消</button>
                            </td>
                          </tr>
                        ) : (
                          <tr key={r.id}>
                            <td>{r.sourceName}</td>
                            <td>{r.recordedAt?.replace("T", " ").slice(0, 16)}</td>
                            <td>{r.glucose}</td>
                            <td>{r.type === 0 ? "空腹" : "飯後"}</td>
                            <td>{r.notes}</td>
                            <td>{r.isAbnormal ? "⚠️" : "✅"}</td>
                            <td>
                              <button className="btn btn-outline-primary btn-sm me-1" onClick={() => handleEdit(r)}>編輯</button>
                              <button className="btn btn-outline-danger btn-sm" onClick={() => handleDelete(r.id)}>刪除</button>
                            </td>
                          </tr>
                        )
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>關閉</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
    </>
  );
}

export default AdminBloodSugarHistory;
